import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem, Chip } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, CHALLAN_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, getModValue, getModVisiblity, linksUrl, SALE_PUR_ENTRY_TYPE } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { faCancel, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { Drawer } from "@mui/material"
import { calculateTotal, funCheckNumber } from "../../Utility/utility"
import InwardItemsEntry from "../salesentry/InwardItemsEntry"


const CreateChallanEntry = () => {
    const { compCode, isMultipleCompany ,startDate,endDate} = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.challanEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    let [selInwardItemsData, setSelInwardItemsData] = useState([])
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selTradeOf, setSelTradeOf] = useState()
    const [selBillType, setSelBillType] = useState()
    const [inwItemSettingMod, setInwItemSettingMod] = useState("")
    const { challnid, challntype } = useParams();
    const [modSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("")

    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMatserData } = usePost({
        url: apiRoute.transaction.PurchaseEntry.entryMasterData,
        queryKey: "fetchChallanMasterData",
        // onSuccessTasks: onSuccessMastData

    })

    const onSuccessVouno = (data) => {
        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.vouNo]: data[0].new_vou_no,
            }))
        }
    }
    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.transaction.challanEntry.generateVoucherNo,
        queryKey: "generate-vouno",
        onSuccessTasks: onSuccessVouno
    })

    const onSuccessTasks = (data) => {
        navigate(linksUrl.transaction.ChallanEntry + challntype + "/" + challnid);
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.transaction.challanEntry.add_update,
        queryKey: "funAddUpdateChallan",
        onSuccessTasks
    })

    const onSuccessInwardItem = (data) => {
        //toggleDrawer(true)

        setSelInwardItemsData(data)
    }
    const { isError: isErrorInwarditemData, data: inwardItemData = [], mutate: filterInwardItemData } = usePost({
        url: apiRoute.transaction.challanEntry.fetchEntryStock,
        queryKey: "fetchitemsData",
        onSuccessTasks: onSuccessInwardItem

    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.transaction.challanEntry.fetchEntryDetail,
        queryKey: "fetchChallanDetail",
    });

    const onSuccessChkChalNo = (data) => {

        if (data && data.length > 0) {
            setFormData({ ...formData, [formField.challanNo]: "" })
            toast.error("Chall No Exist Enter Another", {
                "position": "top-center"
            })
        }
    }
    const { mutate: funchkChalNo } = usePost({
        url: apiRoute.production.checkChalNo,
        queryKey: "funcheck  Duplicate ChalNo",
        onSuccessTasks: onSuccessChkChalNo
    })

    const funGetDupChalNo = (party_id, chal_no) => {
        if (party_id != "" && chal_no != "") {
            funchkChalNo({
                data: {
                    compcode: compCode.join(","),
                    chal_no: chal_no,
                    rp_id: party_id
                }
            })
        }
    }
    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modeSetting.getModSetting,
        queryKey: "fetchModSettingInwardItem",
    })

    let gridData = []
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        const params = [SALE_PUR_ENTRY_TYPE.GrayCloth, SALE_PUR_ENTRY_TYPE.Yarn, SALE_PUR_ENTRY_TYPE.Millgin, SALE_PUR_ENTRY_TYPE.General]
        const paramtype = [CHALLAN_TYPE.Sale, CHALLAN_TYPE.Purchase]
        if (!params.includes(String(challnid)) || !paramtype.includes(String(challntype)))
            navigate(linksUrl.dashboard.tradingDashboard)


        if (challnid && challnid != "" && startDate && startDate != "" && startDate != null && endDate && endDate != "" && endDate != null) {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_billtype = ''
            let t_challntype = challntype.toLowerCase()
            let t_modName = ''
            let t_challnid = challnid.toLowerCase()

            if (t_challntype == CHALLAN_TYPE.Sale) {
                t_billtype = 'S'
                if (t_challnid == SALE_PUR_ENTRY_TYPE.GrayCloth.toLowerCase()) {
                    t_tradeof = 'C'
                    t_entryLabel = "Gray Cloth Sale "
                    t_modName = [ENUM_MOD_NAME.GraySaleMulti]
                    setInwItemSettingMod(ENUM_MOD_NAME.GrayPurchaseTakaEntry)
                }
                else if (t_challnid == SALE_PUR_ENTRY_TYPE.Yarn.toLowerCase()) {
                    t_tradeof = 'Y'
                    t_entryLabel = "Yarn Sale"
                    t_modName = ENUM_MOD_NAME.YarnSaleChallan
                    setInwItemSettingMod(ENUM_MOD_NAME.YarnSaleCarton)
                    // console.log(t_modName)
                }
            }

            else if (t_challntype == CHALLAN_TYPE.Purchase) {
                t_billtype = 'P'

                if (t_challnid == SALE_PUR_ENTRY_TYPE.GrayCloth.toLowerCase()) {
                    t_tradeof = 'C'
                    t_entryLabel = "Gray Cloth Purchase"
                    t_modName = ENUM_MOD_NAME.GrayPurchaseChallan
                    setInwItemSettingMod(ENUM_MOD_NAME.GrayPurchaseTakaEntry)
                }
                else if (t_challnid == SALE_PUR_ENTRY_TYPE.Yarn.toLowerCase()) {
                    t_tradeof = 'Y'
                    t_entryLabel = "Yarn Purchase"
                    t_modName = ENUM_MOD_NAME.YarnPurchaseChallan
                    setInwItemSettingMod(ENUM_MOD_NAME.YarnPurchaseCarton)
                }

            }
            setSelBillType(t_billtype)
            setSelTradeOf(t_tradeof)
            setEntryLabel(t_entryLabel)

            filterModSetting({
                data: {
                    mod_name: t_modName,
                }
            })

            filterMatserData({
                data: {
                    compcode: compCode.join(","),
                    trade_of: t_tradeof,
                    bill_type: t_billtype
                }
            })

            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, transaction_id, bill_type } = detailParams
                funGetDetail({
                    data: {
                        compcode: comp_code,
                        transactionid: transaction_id,
                        billtype: bill_type
                    }
                })
            }
        }

    }, [challnid,startDate,endDate])


    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const modData = modSetting
            setModSettingParams({
                Visibility: {
                    [RowsField.itemDetail]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridItemDet, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.ColorCode, modData) ?? false,
                    [RowsField.cartonNo]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridCartonNo, modData) ?? false,
                    [RowsField.color]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridColor, modData) ?? false,
                    [RowsField.subCat]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridSubCat, modData) ?? false,
                    [RowsField.marko]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridMarko, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridLotNo, modData) ?? false,
                    [RowsField.grossWeight]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridGrossWgt, modData) ?? false,
                    [RowsField.tareWeight]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridTareWgt, modData) ?? false,
                    [RowsField.orderNo]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.GridOrderNo, modData) ?? false,
                    [RowsField.designNo]: getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.DesignNo, modData) ?? false,
                    "cartonDetail": getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.CartonDetail, modData) ?? false,



                }

            })
        }

    }, [modSetting])
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {
            gridData = detail?.itemDetail.map((item, i) => {
                return {
                    id: ++i,
                    itemCode: item?.Item_Code ?? "",
                    itemDetail: item?.item_det ?? "",
                    //itemName: item?.item_desc ?? "",
                    unit: item?.Item_Unit ?? "",
                    pcs: item?.Nos ?? 0,
                    cut: item?.Cut ?? 0,
                    meter: item?.Meter ?? 0,
                    weight: item?.Weight ?? 0,
                    rate: item?.Rate ?? 0,
                    amount: item?.Amount ?? 0,
                    detailId: item?.DetailId ?? 0,
                    color: item?.Color ?? "",
                    subCat: item?.Sub_Cat ?? "",
                    marko: item?.Marko ?? "",
                    orderNo: item?.Ord_No ?? "",
                    colorCode: item?.Color_Id ?? "",
                    cartonNo: item?.CartonNo ?? "",
                    lotNo: item?.lotNo ?? "",
                    grossWeight: item?.GWeight ?? "",
                    tareWeight: item?.TWeight ?? "",
                    designNo: item?.DesignNo ?? "",
                    objSelectedInwItem: [],

                }
            })
        }
    }

    const formField = {
        transId: "transId",
        vouNo: "vouNo",
        bookId: "bookId",
        partyId: "partyId",
        challanNo: "challanNo",
        challanDate: "challanDate",
        remark: "remark",
        pcs: "pcs",
        meter: "meter",
        weight: "weight",
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.challanDate)
            acc[key] = new Date()
        else if (key == formField.netAmount || key == formField.pcs || key == formField.meter || key == formField.weight)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [rows, setRows] = useState([])
    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const RowsField = {
        detailId: "detailId",
        id: "id",
        itemCode: "itemCode",
        itemName: "itemName",
        unit: "unit",
        rate: "rate",
        cut: "cut",
        amount: "amount",
        pcs: "pcs",
        meter: "meter",
        weight: "weight",
        designNo: "designNo",
        cartonNo: "cartonNo",
        marko: "marko",
        lotNo: "lotNo",
        grossWeight: "grossWeight",
        tareWeight: "tareWeight",
        color: "color",
        shade: "shade",
        orderNo: "orderNo",
        colorCode: "colorCode",
        objSelectedInwItem: "objSelectedInwItem"

    }
    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.unit]: "",
        [RowsField.cut]: "",
        [RowsField.rate]: 0,
        [RowsField.cut]: 0,
        [RowsField.amount]: 0,
        [RowsField.pcs]: 0,
        [RowsField.meter]: 0,
        [RowsField.weight]: 0,
        [RowsField.designNo]: "",
        [RowsField.cartonNo]: "",
        [RowsField.marko]: "",
        [RowsField.lotNo]: "",
        [RowsField.grossWeight]: 0,
        [RowsField.tareWeight]: 0,
        [RowsField.color]: "",
        [RowsField.shade]: "",
        [RowsField.orderNo]: "",
        [RowsField.objSelectedInwItem]: [],
    }
    const itemGridHeadClass = "bill-grid-style"
    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {
        Row1: [
            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Voucher No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },

        ],

        Row2: [
            {
                id: formField.bookId,
                name: formField.bookId,
                placeholder: "Book Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.grayMaster ? masterData?.grayMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.partyId,
                name: formField.partyId,
                placeholder: "Party Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
        ],
        Row3: [
            {
                id: formField.challanNo,
                name: formField.challanNo,
                placeholder: "Challan No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.challanDate,
                name: formField.challanDate,
                placeholder: " Challan Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],

    }

    const hanldeBlur = (index, e) => {
        const { value, name } = e.target
        if (name == formField.challanNo) {
            funGetDupChalNo(formData[formField.partyId], value)
        }

    }

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    const toggleDrawer = (isOpen) => (event) => {
        // Close drawer if the event is a keyboard event and the key is 'Tab' or 'Escape'
        const e_type = event.type ?? ""
        if (e_type === 'keydown' && (e_type === 'Tab' || e_type === 'Escape')) {
            setOpenDrawer(false);
            return;
        }
        setOpenDrawer(isOpen);
    };


    const handleAutoCompleteChange = (value, rowid, name) => {

        if (name == formField.partyId || name == formField.bookId) {
            if (name == formField.partyId) {
                funGetDupChalNo(value, formData[formField.challanNo])
            }
            if (name == formField.bookId) {

                generateVouNo({
                    data: {
                        comp_code: compCode.join(","),
                        vou_type: 'P',
                        p_id: value,
                        trade_of: selTradeOf,
                        vou_of: '',
                        start_date:dayjs(startDate).format("YYYY-MM-DD"),
                        end_date:dayjs(endDate).format("YYYY-MM-DD"),
                    }
                })

            }
            setFormData({
                ...formData,
                [name]: value,

            })
        }

        else {
            if (rows.find((ele) => ele.itemCode == value)) {
                toast.error("Item already added", {
                    "position": "top-center"
                })
                const index = rows.findIndex((ele) => ele.id == rowid)
                let newRow = [...rows]
                newRow[index].itemCode = ""
                newRow[index].itemName = ""
                newRow[index].unit = ""
                setRows(newRow)
            }
            else {
                const index = rows.findIndex((ele) => ele.id == rowid)
                setSelectedGridRowId(index)

                const tempdata = masterData.itemMaster
                const itemData = tempdata.filter((ele) => ele.Item_Code == value)

                let newRow = [...rows]

                if (itemData && itemData.length > 0) {
                    newRow[index].itemCode = itemData[0].Item_Code
                    newRow[index].itemName = itemData[0].Item_Desc
                    newRow[index].unit = itemData[0].Item_Unit
                    setRows(newRow)
                }
                // setMsg("")
            }
        }



    }
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        setRows(updatedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])
    }
    const funCalAllAmount = (rowData, index, meter, pcs, weight) => {

        let newRows = [...rows]
        if (rowData && rowData.length > 0)
            newRows = [...rowData]
        let t_Amount = 0
        let tempVal = 0
        let t_rate = newRows[index].rate && newRows[index].rate != null ? newRows[index].rate : 0
        const t_unit = newRows[index].unit ? newRows[index].unit.toLowerCase() : ""
        const t_meter = meter && meter != null && meter > 0 ? meter : newRows[index].meter ?? 0
        const t_pcs = pcs && pcs != null && pcs > 0 ? pcs : newRows[index].pcs ?? 0
        const t_weight = weight && weight != null && weight != "" && weight > 0 ? weight : newRows[index].weight ?? 0

        if (t_unit != "") {
            if (t_unit == "mtr" || t_unit == "ltr") {
                tempVal = parseFloat(t_rate) * parseFloat(t_meter)
            }
            else if (t_unit == "kgs" || t_unit == "grm")
                tempVal = parseFloat(t_rate) * parseFloat(t_weight)
            else
                tempVal = parseFloat(t_rate) * parseFloat(t_pcs)
        }
        else
            tempVal = parseFloat(t_rate) * parseFloat(t_pcs)

        t_Amount = funCheckNumber(tempVal)
        return { amount: t_Amount }

    }
    //end delete row from dynamic grid
    const handleInputChange = (rowId, e, name) => {

        let { value, id } = e.target
        let index = rows.findIndex(ele => ele.id == rowId)
        const newRows = [...rows]
        newRows[index][id] = value
        // if (id == RowsField.rate) newRows[index][id] = value
        // else if (id == RowsField.cut) newRows[index][id] = value
        // else if (id == RowsField.weight) newRows[index][id] = value
        // else if (id == RowsField.amount) newRows[index][id] = value
        // else if (id == RowsField.meter) newRows[index][id] = value
        // else if (id == RowsField.pcs) newRows[index][id] = value
        // else if (id == RowsField.shade) newRows[index][id] = value
        // else if (id == RowsField.designNo) newRows[index][id] = value
        if (id == RowsField.rate ||
            id == RowsField.pcs ||
            id == RowsField.weight ||
            id == RowsField.meter) {

            const calData = funCalAllAmount(newRows, index, 0, 0, 0)
            newRows[index].amount = calData.amount
        }
        setRows(newRows)
    }
    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (
            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                type={input_type}
                size="sm"
                // label=""
                labelPlacement="outside"
                readOnly={is_readonly}
                placeholder={holder_text}
                //allow space in text box
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                value={row[input_id]}
                onChange={(e) => handleInputChange(row.id, e, "")}
                className="max-w-xs mt-1"
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}

            ></Input>
        )
    }

    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <strong>
                    <FontAwesomeIcon
                        color="red"
                        className="cursor-pointer"
                        onClick={() => handleDeleteRow(row.id)}
                        icon={faSquareXmark}
                    ></FontAwesomeIcon>
                </strong>
            ),
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            width: 80,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>
                {row.itemCode}
            </div>)

            //renderInputCell(row, RowsField.acYear, "text", false, "Ac.Year", true),
        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            width: 300,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    <Autocomplete
                        isRequired
                        size="sm"
                        color={"success"}
                        id={RowsField.itemName}
                        eventResizeFeature={true}
                        selectionMode="single"
                        showScrollIndicators={true}
                        placeholder="--Select--"
                        className="max-w-23"
                        menuTrigger={"input"}
                        isClearable={false}
                        isLoading={isLoadingData}
                        isVirtualized
                        defaultItems={
                            masterData && masterData.itemMaster ? masterData?.itemMaster : []
                        }
                        onSelectionChange={(e) =>
                            handleAutoCompleteChange(e, row.id)
                        }
                        //onChange={handleFormSelectionChange}
                        selectedKey={row.itemCode}
                    >
                        {(item) => (
                            <AutocompleteItem
                                key={item.Item_Code}
                            >
                                {item.Item_Code + "(" + item.Item_Desc + ")"}
                            </AutocompleteItem>
                        )}
                    </Autocomplete>

                    {modSettingParams?.Visibility?.cartonDetail
                        ?
                        <Chip size="sm" color="danger" radius="sm"
                            className="ml-3 cursor-pointer" variant="shadow"
                            onClick={() => handleItems(row.id)}>
                            {selTradeOf == 'Y' ? "View Cobs" : "View Taka"}</Chip>
                        : ""}
                    {/* <Chip size="sm" color="danger" radius="sm"
                        className="ml-3 cursor-pointer" variant="shadow"
                        onClick={() => handleItems(row.id)}>View Taka</Chip> */}

                </div>
            ),
        },
        {
            field: RowsField.designNo,
            headerName: "Design No",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.designNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.shade,
            headerName: "Shade",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.shade, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.color,
            headerName: "Color",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.color, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.colorCode,
            headerName: "Clr.Code",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.colorCode, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.marko,
            headerName: "Marko",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.marko, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.itemDetail,
            headerName: "Item Detail",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.itemDetail, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.unit,
            headerName: "Unit",
            width: 80,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {row[RowsField.unit]}
                </div>)
        },
        {
            field: RowsField.orderNo,
            headerName: "Order No",
            width: 80,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => renderInputCell(row, RowsField.orderNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.cartonNo,
            headerName: "Carton No",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.cartonNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.lotNo,
            headerName: "Lot No",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.lotNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.grossWeight,
            headerName: "Gross Wgt.",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.grossWeight, "number", false, "", false, "", ""),
        },
        {
            field: RowsField.tareWeight,
            headerName: "Tare Wgt.",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.tareWeight, "number", false, "", false, "", ""),
        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.pcs, "number", false, "", false, "", "")
            //selTradeOf == 'C' && modeSettingParams?.Visibility?.takaView ? true : false, "", false, "", ""),

        },
        {
            field: RowsField.cut,
            headerName: "Cut",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.cut, "number", false, "", false, "", "")

        },
        {
            field: RowsField.meter,
            headerName: "Meter",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.meter, "number",
                    false,
                    // selTradeOf == 'C' && modeSettingParams?.Visibility?.takaView ? true : false
                    "", false, "", ""),
        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.weight, "number",
                    false,
                    // selTradeOf == 'C' ? !modeSettingParams?.Visibility?.takaView && isManualEntry ? false : true : false
                    "", false, "", ""),
        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.rate, "number", false, "", false, "", ""),
        },
        {
            field: RowsField.amount,
            headerName: "Amount",
            width: 130,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.amount]}
                </div>)
        },

    ]
    const [errors, setErrors] = useState({})


    const handleItems = (id) => {
        //        if (modeSettingParams?.Visibility?.takaView) {
        const index = rows.findIndex((ele) => ele.id == id)


        if (rows[index][RowsField.itemCode] != "" && rows[index][RowsField.itemCode] != "0") {
            //                setMsg("")
            if ((rows[index]?.objSelectedInwItem && rows[index].objSelectedInwItem.length <= 0) ||
                (rows[index]?.objSelectedInwItem[0].Item_Code != rows[index][RowsField.itemCode])) {
                //console.log(index, rows[index][RowsField.itemCode])
                filterInwardItemData({
                    data: {
                        compcode: compCode.join(","),
                        item_code: rows[index][RowsField.itemCode],
                        chal_no: isNewEntry ? null : formData.challanNo,
                        action: isNewEntry ? "NEWDATA" : "UPDATEDATA",
                        bill_type: selBillType,
                        trade_of: selTradeOf

                    }
                })
                // setOpenDrawer(true)
            }
            else {

                setSelInwardItemsData(rows[index].objSelectedInwItem)

                // const cur_Taka = rows.map(ele => ele.objSelectedTaka.filter(item => item.isAdded == 1))
                // let selItems = []
                // for (let i = 0; i < cur_Taka.length; i++) {
                //     selItems = [...selItems, ...cur_Taka[i]]
                // }
                //setCurrentTaKaList(selItems)//check duplicate taka in current list when multiple item sleected
                setOpenDrawer(true)
            }
            // }
            setSelectedGridRowId(id)
            setOpenDrawer(true)
        }
        else {
            //setMsg("Select Item")
            toast.error("Select Item", {
                "position": "top-center"
            })
        }
        //}

    }

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.vouNo] = "Voucher No required"
        }

        if (formData[formField.partyId] == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Party Name required"
        }
        if (formData[formField.bookId] == "" || formData[formField.bookId] == "0") {
            newErrors[formField.bookId] = "Book Name required"
        }

        if (formData.challanNo.trim() == "") {
            newErrors[formField.challanNo] = "Challan No required"
        }
        if (formData[formField.challanDate] == null || formData[formField.challanDate] == "" || formData[formField.challanDate] == "Invalid Date") {
            newErrors[formField.challanDate] = "Challan Date required"
        }



        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }
    const funGetPcs = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selTradeOf == 'C') {
                if (selItemdata.find(el => el.CartonNo)) {
                    return selItemdata.length
                }
            }
            else {
                if (selItemdata.find(el => el.Pcs)) {
                    return calculateTotal({
                        data: selItemdata,
                        columnName: "Pcs",
                    })
                }
            }
            return 0
        }
        else
            return 0
    }
    const funGetMeter = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selItemdata.find(el => el.Meter)) {
                return calculateTotal({
                    data: selItemdata,
                    columnName: "Meter",
                })
            }
            return 0
        }
        else
            return 0
    }
    const funGetWeight = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selItemdata.find(el => el.Weight)) {
                return calculateTotal({
                    data: selItemdata,
                    columnName: "Weight",
                })
            }
            return 0
        }
        else
            return 0
    }
    const funGetGrossWeight = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selItemdata.find(el => el.GWeight)) {
                return calculateTotal({
                    data: selItemdata,
                    columnName: "GWeight",
                })
            }
            return 0
        }
        else
            return 0
    }
    const funGetTareWeight = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selItemdata.find(el => el.TWeight)) {
                return calculateTotal({
                    data: selItemdata,
                    columnName: "TWeight",
                })
            }
            return 0
        }
        else
            return 0
    }
    const funGetYarnPcs = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selItemdata.find(el => el.Pcs)) {
                return calculateTotal({
                    data: selItemdata,
                    columnName: "Pcs",
                })
            }
            return 0
        }
        else
            return 0
    }
    const handleSelectedInwardItem = (data) => {
        if (data && Object.keys(data).length > 0) {
            const selItem = data.item
            const delItem = isNewEntry ? [] : data.deletedItem.map(ele => String(ele.TakaId))
            const index = rows.findIndex((ele) => ele.id == selectedGridRowId)

            let tot_pcs = funGetPcs(selItem)

            let tot_weight = funGetWeight(selItem)
            let tot_meter = funGetMeter(selItem)
            let tot_grossWt = funGetGrossWeight(selItem)
            let tot_tareWt = funGetTareWeight(selItem)
            // setSelGrayItemsData(data)
            const updateRow = {
                ...rows[index], objSelectedInwItem: selItem, delInwItemIds: delItem,
                pcs: tot_pcs, weight: tot_weight, meter: tot_meter
                , grossWeight: tot_grossWt, tareWeight: tot_tareWt
            };
            const newRows = [...rows]
            newRows[index] = updateRow
            setRows(newRows)
        }
    }

    useEffect(() => {
        validateForm();
    }, [formData])


    const handleSubmit = (e) => {
        e.preventDefault()
        let tot_Nos = 0
        let tot_Mtr = 0
        let tot_Weight = 0

        rows.map((ele) => {
            tot_Nos += ele?.pcs ? Number(ele?.pcs) : 0
            tot_Mtr += ele?.meter ? parseFloat(ele?.meter) : 0
            tot_Weight += ele?.weight ? parseFloat(ele?.weight) : 0
        })
        console.log(rows)
        const validate_form = validateForm()
        if (validate_form) {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    item_list: rows,
                    deleteditem_list: deletedItemRows,
                    trans_id: formData[formField.transId],
                    bill_type: selBillType,
                    inward_type: selBillType,
                    trade_of: selTradeOf,
                    nos: tot_Nos,
                    meter: tot_Mtr,
                    weight: tot_Weight,
                    vou_no: formData[formField.vouNo],
                    book_id: formData[formField.bookId],
                    party_id: formData[formField.partyId],
                    challan_no: formData[formField.challanNo],
                    challan_date: formData[formField.challanDate],
                    net_amount: net_Amount,
                    login_userid: user.username,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            setRows(gridData)
            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.vouNo]: detail?.itemData[0]?.Vou_No ?? "",
                    [formField.bookId]: detail?.itemData[0]?.Ac_Id ?? "",
                    [formField.partyId]: detail?.itemData[0]?.Pac_Id ?? "",
                    [formField.challanNo]: detail?.itemData[0]?.Chal_No ?? "",
                    [formField.challanDate]: detail?.itemData[0]?.Chal_Date ?? "",
                    // [formField.remark]: detail[0]?.vou_type ?? "",
                    [formField.pcs]: detail?.itemData[0]?.Pcs ?? "",
                    [formField.meter]: detail?.itemData[0]?.Meter ?? "",
                    [formField.weight]: detail?.itemData[0]?.Weight ?? "",

                })
            }
        }

    }, [detail])
    const handleClickPrev = () => {
        navigate(linksUrl.transaction.ChallanEntry + challntype + "/" + challnid)
    }
    const handleAddRow = () => {
        const newRow = { id: rows.length + 1, ...initialRow, }
        setRows([...rows, newRow])
    }


    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel} Challan Entry`}
                breadcrumbs={[selBillType == "S" ? "Sale" : "Purcahse", entryLabel, "Challan Entry"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <div shadow="sm" className="mb-3 w-full">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <Autocomplete
                                                        size="md"
                                                        name={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        label={item?.placeholder}
                                                        eventResizeFeature={true}
                                                        selectionMode="single"
                                                        showScrollIndicators={true}
                                                        labelPlacement={"outside"}
                                                        placeholder={item.placeholder}
                                                        isRequired={item.isrequired}
                                                        isLoading={isLoadingData}
                                                        className="max-w-23"
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                        isClearable={false}
                                                        isVirtualized
                                                        readonly={isNewEntry ? false : true}
                                                        defaultItems={
                                                            item.data ? item.data : []
                                                        }
                                                        onSelectionChange={(e) =>
                                                            handleAutoCompleteChange(e, '', item.name)
                                                        }
                                                        color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                        //onChange={handleFormSelectionChange}
                                                        selectedKey={formData[item.name]}
                                                    >
                                                        {(list) => (
                                                            <AutocompleteItem

                                                                key={list[item.itemkey]}
                                                            >
                                                                {list[item.itemvalue]}
                                                            </AutocompleteItem>
                                                        )}
                                                    </Autocomplete>

                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name])
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => {
                                                                    setFormData((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                        };
                                                                    });
                                                                }}
                                                                //isRequired={item.required}
                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: { size: "small", error: errors[item.name], helperText: errors[item.name], required: true },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : (
                                                    <Input
                                                        type={item.type}
                                                        name={item.name}
                                                        id={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        placeholder={item.placeholder}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        isRequired={item.isrequired}
                                                        value={formData[item.name]}
                                                        variant="bordered"
                                                        onChange={(e) => handleChange(e)}
                                                        onBlur={(e) => hanldeBlur("", e)}
                                                        readOnly={item.name == formField.vouNo ? true : false}
                                                        size={"md"}
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                    ></Input>
                                                )
                                            )
                                        }
                                    </div>

                                </div>

                            ))
                        }

                        <div>
                            <Button size="sm" color="success" className="text-white" startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow" onPress={handleAddRow}>
                                ADD ITEM
                            </Button>

                            {rows && rows?.length > 0 ? (
                                //150+ style={{ height:50+ Number(rows.length * 51), overflow: "auto" }}
                                <div style={{ height: 45 + Number(rows.length * 51), overflow: "auto" }} >
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        editMode="row"
                                        hideFooterPagination={true}
                                        hideFooter={true}
                                        columnHeaderHeight={35}
                                        rowHeight={45}
                                        disableColumnSorting={true}
                                        disableColumnMenu={true}
                                        columnVisibilityModel={{
                                            [RowsField.cartonNo]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.cartonNo] : true,
                                            [RowsField.color]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.color] : true,
                                            [RowsField.colorCode]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.color] : true,
                                            [RowsField.itemDetail]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.itemDetail] : true,
                                            [RowsField.marko]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.marko] : true,
                                            [RowsField.lotNo]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.lotNo] : true,
                                            [RowsField.orderNo]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.orderNo] : true,
                                            [RowsField.grossWeight]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.grossWeight] : true,
                                            [RowsField.tareWeight]: modSetting && modSetting?.length > 0 ? modSettingParams?.Visibility[RowsField.tareWeight] : true,
                                        }}

                                    />
                                </div>
                            ) : (
                                ""
                            )}

                            <Drawer open={openDrawer} onClose={toggleDrawer(false)} anchor={"left"}  >
                                <div>
                                    <div onClick={toggleDrawer(false)} className="absolute right-0  ">
                                        <FontAwesomeIcon className="text-rose-600  cursor-pointer text-3xl" icon={faSquareXmark} />
                                    </div>
                                    <div className="py-2 text-center font-semibold bg-red-100 text-red-700 text-sm">
                                        {selTradeOf == "C" && selBillType == "P" ? "Gray Cloth Purchase Challan Taka Entry" :
                                            selTradeOf == "Y" && selBillType == "P" ? "Yarn Purchase Challan Carton Entry" : ""}
                                        {selTradeOf == "C" && selBillType == "S" ? "Gray Cloth Sale Challan Taka Entry" :
                                            selTradeOf == "Y" && selBillType == "S" ?
                                                "Yarn Sale Challan Carton Entry" : ""}
                                    </div>
                                    {/* {inwardItemData & inwardItemData.length > 0 ? */}
                                    <div className={isMobile ? "w-80  overflow-scroll" : ""}>
                                        <InwardItemsEntry tradeOf={selTradeOf} settingMode={inwItemSettingMod} inwardItemData={selInwardItemsData} handleSelectedInwardItem={handleSelectedInwardItem} />
                                    </div>
                                    {/* : <h2 className="text-center text-pink-700 p-5   m-10 bg-rose-50" >Data not found</h2>} */}
                                </div>


                            </Drawer>
                        </div>
                        <div>
                            <div className="flex  items-top gap-2 mt-7 ">
                                <Input
                                    size="sm"
                                    type="number"
                                    label="Net Amount"
                                    placeholder="Net Amount"
                                    value={Number(net_Amount ?? 0)}
                                    className="max-w-25"
                                    variant="flat"
                                    color="success"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">₹</span>
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                        <div className="justify-center flex gap-5 mt-5">
                            <Button
                                color="primary"
                                type="submit"
                                size="md"
                                variant="shadow"
                                tabIndex={-1}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit
                            </Button>
                            <Button
                                color="danger"
                                variant="shadow"
                                size="md"
                                tabIndex={-1}
                                onPress={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form >
                </div >
            </MainContainer >
        </div >
    )

}
export default CreateChallanEntry